<template>
  <div class="mc-delivery-tabs">
    <b-button
      v-for="tab in tabMappings"
      variant="light"
      :key="tab.key"
      :value="tab.key"
      :class="{ active: tab.key == activeTab }"
      :disabled="isLoading"
      @click="handleClickTab"
    >
      {{ tab.name }}
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'FleetTaskInstantTabs',
  props: {
    activeTab: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
    },
  },
  emits: ['update:activeTab', 'showData'],
  computed: {
    tabMappings() {
      const tabs = [
        {
          key: 'MAIN-INFORMATION',
          name: this.$t('fleetTaskInstant.tab.mainInformation'),
        },
        {
          key: 'ADDITIONAL-INFORMATION',
          name: this.$t("fleetTaskInstant.tab.additionalInformation"),
        },
      ]

      if (this.isQaOnDemand) {
        return tabs.filter((tab) => tab.key !== 'ADDITIONAL-INFORMATION')
      }

      return tabs
    },
    isQaOnDemand() {
      return this.$store.state.identity.whoami?.accessRight === 'QA On Demand'
    },
  },
  methods: {
    handleClickTab(e) {
      if (e.target.value == this.activeTab) return

      this.$emit('update:activeTab', e.target.value)
    },
  },
}
</script>

<style lang="scss" scoped>
.mc-delivery-tabs {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  margin-bottom: 12px;

  & > button {
    height: 36px;
    flex-shrink: 0;
    color: $mep-color-text;
    font-weight: 500;
    transition: none;
    background: none;
    outline: none;
    border: none;
    border-radius: 4px;
    padding: 8px 20px;

    &:hover {
      background-color: $mep-secondary-100;
      color: $mep-color-text-400;
    }

    &:focus {
      outline: none;
    }

    &:disabled {
      color: #67718b;
    }
  }

  & > button.active {
    border: 1px solid $mep-primary;
    background-color: $mep-secondary-100;
    color: $mep-primary;
    font-weight: 600;
  }
}
</style>
